import { AxiosError } from 'axios'
import { ENDPOINT_SUPER_AGENT } from '../config'
import AuthAxios from '@/lib/api/axios/AuthAxios'

/**
 * Disable the Super Agent for a project. The backend blocks (409) while any task is
 * still in an AI status — surfaced here as a clear, user-actionable error.
 */
const offboardSuperAgent = async (workspaceSlug: string, projectId: string): Promise<void> => {
  try {
    await AuthAxios.delete(`${ENDPOINT_SUPER_AGENT}/${workspaceSlug}/projects/${projectId}/super-agent`)
  } catch (error) {
    if (error instanceof AxiosError && error.response?.status === 409) {
      const message = (error.response.data as { message?: string } | undefined)?.message
      throw new Error(
        message ?? 'Some tasks are still in AI statuses — move them to a human status before disabling.',
      )
    }
    if (error instanceof AxiosError && error.response?.status === 403) {
      throw new Error('Enable AI for this workspace to manage the Super Agent.')
    }
    throw error
  }
}

export default offboardSuperAgent
